export default "__VITE_ASSET__Bo2flq2Z__"